"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchUpStatusEnum = void 0;
var MatchUpStatusEnum;
(function (MatchUpStatusEnum) {
    MatchUpStatusEnum["ABANDONED"] = "ABANDONED";
    MatchUpStatusEnum["BYE"] = "BYE";
    MatchUpStatusEnum["COMPLETED"] = "COMPLETED";
    MatchUpStatusEnum["DEAD_RUBBER"] = "DEAD_RUBBER";
    MatchUpStatusEnum["DEFAULTED"] = "DEFAULTED";
    MatchUpStatusEnum["DOUBLE_DEFAULT"] = "DOUBLE_DEFAULT";
    MatchUpStatusEnum["INCOMPLETE"] = "INCOMPLETE";
    MatchUpStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    MatchUpStatusEnum["NOT_PLAYED"] = "NOT_PLAYED";
    MatchUpStatusEnum["RETIRED"] = "RETIRED";
    MatchUpStatusEnum["SUSPENDED"] = "SUSPENDED";
    MatchUpStatusEnum["TO_BE_PLAYED"] = "TO_BE_PLAYED";
    MatchUpStatusEnum["WALKOVER"] = "WALKOVER";
    MatchUpStatusEnum["DOUBLE_WALKOVER"] = "DOUBLE_WALKOVER";
    MatchUpStatusEnum["CANCELLED"] = "CANCELLED";
    MatchUpStatusEnum["AWAITING_RESULT"] = "AWAITING_RESULT";
})(MatchUpStatusEnum || (exports.MatchUpStatusEnum = MatchUpStatusEnum = {}));
//# sourceMappingURL=matchup_status.js.map